/* @flow */
import React from 'react';
import Checkbox from 'components/Checkbox.jsx';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import Input from 'components/Input.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import SettingsStore from 'stores/SettingsStore';

import { includes, without } from 'lodash';

import './styles/GradeLevelPicker.scss';

type Props = {
  onClose: (gradeLevels: string[]) => void,
  initialGrades: string[],
};

type Grade = {
  name: string,
  short_name: string,
  code: string,
};

class GradeLevelPicker extends React.Component {
  props: Props;

  state = {
    selectedGrades: [],
  }

  componentWillMount() {
    if (this.props.initialGrades) {
      this.setState({ selectedGrades: this.props.initialGrades });
    }
  }

  isSelected = (gradeCode: string) => {
    return includes(this.state.selectedGrades, gradeCode);
  }

  toggleGrade = (gradeCode: string) => {
    const { selectedGrades } = this.state;
    if (this.isSelected(gradeCode)) {
      this.setState({ selectedGrades: without(selectedGrades, gradeCode) });
    } else {
      this.setState({ selectedGrades: selectedGrades.concat(gradeCode) });
    }
  }

  menuItemForGrade = (grade: Grade) => {
    return (
      <MenuItem className="GradeLevelPicker-menuItem" key={grade.code} onSelect={this.toggleGrade}>
        <Checkbox checked={this.isSelected(grade.code)} label={grade.name} />
      </MenuItem>
    );
  }

  onHide = () => {
    this.props.onClose(this.state.selectedGrades);
  }

  render() {
    const { selectedGrades } = this.state;
    const menu = (
      <Menu ref="gradePickerMenu" className="GradeLevelPicker-menu" hideOnSelect={false}>
        {SettingsStore.getSetting('grades').map(this.menuItemForGrade)}
      </Menu>
    );

    let gradeLevelText;
    if (selectedGrades.length > 0) {
      gradeLevelText = selectedGrades.map(code => {
        const grade = SettingsStore.getGradeLevelForCode(code);
        return grade.short_name;
      }).join(', ');
    } else {
      gradeLevelText = 'No grade selected';
    }

    return (
      <LayerTrigger
        layer={menu}
        ref="gradeLevelLayer"
        trigger="click"
        placement="bottom"
        alignment="middle"
        onHide={this.onHide}>
        <Input className="GradeLevelPicker-input" readOnly value={gradeLevelText} />
      </LayerTrigger>
    );
  }
}

export default GradeLevelPicker;



// WEBPACK FOOTER //
// ./src/components/GradeLevelPicker.jsx